import SharedTicketDetailCard from "../../default/components/TicketDetailCard";

const TicketDetailCard = (props) => {
    return <SharedTicketDetailCard variant="partner-service" {...props} />;
};

export default TicketDetailCard;